import { validateInteger } from './integer';

const INT_32_MIN = -2147483648;
const INT_32_MAX = 2147483647;

export function validateInt32(value) {
    if (validateInteger(value)) {
        const parsed = (typeof value === 'string') ?
              parseInt(value, 10) :
              value;

        return parsed >= INT_32_MIN
            && parsed <= INT_32_MAX;
    }
    return false;
}
